jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        if (ns.includes("noPreventDefault")) {
            this.addEventListener("touchstart", handle, { passive: false });
        } else {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    }
};

jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        if (ns.includes("noPreventDefault")) {
            this.addEventListener("touchmove", handle, { passive: false });
        } else {
            this.addEventListener("touchmove", handle, { passive: true });
        }
    }
};

// The function actually applying the offset
function offsetAnchor() {
    if (location.hash.length !== 0) {
      window.scrollTo(window.scrollX, window.scrollY - 180);
    }
}
  
// Captures click events of all <a> elements with href starting with #
$(document).on('click', 'a[href^="#"]', function(event) {
// Click events are captured before hashchanges. Timeout
// causes offsetAnchor to be called after the page jump.
window.setTimeout(function() {
    offsetAnchor();
}, 0);
});
  
  // Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);

/**** MENU ****/

$("#hamburger").on('click', function(){
    $('body').toggleClass("overflow");
    $('.main-navigation').toggleClass("open");
    $(this).toggleClass("open");
});

$(".mobile-hamburger").on('click', function() {
    $('body').removeClass("overflow");
    $('.main-navigation').removeClass("open");
});

$(".show-more").on('click', function(){
    $(this).parent("li").children("ul").toggle();
});

$(window).on('scroll', function () {
    if ($(this).scrollTop() >= 40) {
        $('.header-container').addClass("scroll");
        $('.main-navi-wrapper').addClass("scroll");
        $('.side-menu-wrapper').addClass("scroll");
    } else {
        $('.header-container').removeClass("scroll");
        $('.main-navi-wrapper').removeClass("scroll");
        $('.side-menu-wrapper').removeClass("scroll");
    }
});

/**** END MENU ****/

function formValidation() {
    var forms = document.getElementsByClassName('needs-validation');
    var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener("keydown", function () {
            if (document.querySelector(".invalid-vat")) {
                document.querySelector(".invalid-vat").style.display = "none";
            }
            if (document.querySelector(".invalid-long")) {
                document.querySelector(".invalid-long").style.display = "none";
            }
            if (document.querySelector(".invalid-tooltip")) {
                document.querySelector(".invalid-tooltip").style.display = "none";
            }
        });
        
        form.addEventListener("submit", function (event) {
            if (document.querySelector(".invalid-vat")) {
                document.querySelector(".invalid-vat").style.display = "none";
            }
            if (document.querySelector(".invalid-long")) {
                document.querySelector(".invalid-long").style.display = "none";
            }
            
            if (typeof document.getElementById("password").value === undefined) {
                return false;
            }
            
            if (typeof document.getElementById("password").value !== undefined) {
                var password = document.getElementById("password").value;
            }
            
            if (document.getElementById("vat") !== null) {
                var vat = document.getElementById("vat").value;
                if (vat.length > 8) {
                    document.querySelector(".invalid-long").style.display = "block";
                }
                
                var regex = /^[0-9]{8}$/gm;
                if (!vat.match(regex)) {
                    document.querySelector(".invalid-vat").style.display = "block";
                }
            }
            
            if (document.getElementById("billing_vat_number") !== null) {
                var vat = document.getElementById("billing_vat_number").value;
                if (vat.length > 8) {
                    document.querySelector(".invalid-long").style.display = "block";
                }
                
                var regex = /^[0-9]{8}$/gm;
                if (!vat.match(regex)) {
                    document.querySelector(".invalid-vat").style.display = "block";
                }
            }
            
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                $(form).addClass('has-errors');
            } else {
                $(form).removeClass('has-errors');
                $(form).addClass('submitting');
            }
            form.classList.add('was-validated');
        }, false);
    });
}

if ($("#checkout").length > 0) {
    window.addEventListener('load', formValidation(), false);
}


/*** AUTOCOMPLETE ****/
var searchInput = $('.search-input');
var searchResults = $('.smart-search-results');
if (searchInput.length > 0) {
    var debounceTimer;
    var minCharacters = 3;

    searchInput.on("input", function () {
        clearTimeout(debounceTimer);

        if ($(this).val().length >= minCharacters) {
            debounceTimer = setTimeout(function () {
                performSearch(searchInput.val());
            }, 500);
        } else {
            searchResults.empty().hide();
        }
    });

    function performSearch(query) {
        $.ajax({
            url: "/search/autocomplete/",
            data: { term: query },
            success: function (data) {
                searchResults.html(data).show();
            },
            error: function (error) {
                console.error("Error fetching search results:", error);
                searchResults.empty().hide();
            }
        });
    }

    $("body").on("click", ".smart-search-results .all-results span", function () {
        $("form.search").trigger("submit");
    });
}